import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=6a8e1ebb&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=ts"
export * from "./Step1.vue?vue&type=script&lang=ts"
import style0 from "./Step1.vue?vue&type=style&index=0&id=6a8e1ebb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e1ebb",
  null
  
)

export default component.exports